// ローディング判定
jQuery(window).on("load", function() {
  jQuery("body").attr("data-loading", "true");
});

jQuery(function() {
  // スクロール判定
  jQuery(window).on("scroll", function() {
    let scrollTop = jQuery(this).scrollTop();
    let windowHeight = jQuery(this).height();
    let mvHeight = jQuery(".mv").height();
    let documentHeight = jQuery(document).height();

    if (1 < scrollTop) {
      jQuery("body").attr("data-scroll", "true");
    } else {
      jQuery("body").attr("data-scroll", "false");
    }

    if (documentHeight - (windowHeight + scrollTop) <= 0) {
      jQuery("body").attr("data-scroll-bottom", "true");
    } else {
      jQuery("body").attr("data-scroll-bottom", "false");
    }
  });

  jQuery(".g-nav-child-link").on("click", function(e) {
    let drawer = jQuery(".js-drawer");
    let targetClass = jQuery(drawer).attr("data-target");
    let ariaControls = jQuery(drawer).attr("aria-controls");

    jQuery("." + targetClass).toggleClass("is-checked");
    jQuery(body).toggleClass("is-checked");
    if (jQuery("#" + ariaControls).attr("aria-hidden") === "true") {
      jQuery("#" + ariaControls).attr("aria-hidden", "false");
    } else {
      jQuery("#" + ariaControls).attr("aria-hidden", "ture");
    }

    if (jQuery(drawer).attr("aria-expanded") === "true") {
      jQuery(drawer).attr("aria-expanded", "false");
    } else {
      jQuery(drawer).attr("aria-expanded", "ture");
    }

    /*     jQuery(this).toggleClass("active");
    jQuery(this)
      .closest(".menu-second")
      .slideToggle();
    jQuery(this)
      .not(jQuery(this).closest(".g-nav-item.child"))
      .children(".menu-second")
      .slideUp();
    jQuery(this)
      .not(jQuery(this).hasClass(".active"))
      .toggleClass("active"); */
  });
  /*   } */

  /* ドロワー */
  function closeDrawer() {
    // 閉じるクラス処理
    jQuery(".drawer-bg").removeClass("is-checked");
    jQuery(".drawer-content").removeClass("is-checked");
    jQuery(".drawer-icon").removeClass("is-checked");
    jQuery("body").removeClass("is-checked");

    // aria属性も閉じる状態に
    jQuery(".drawer-icon").attr("aria-expanded", "false");
    jQuery(".drawer-content").attr("aria-hidden", "true");
  }

  jQuery(".js-drawer").on("click", function(e) {
    e.preventDefault();

    let targetClass = jQuery(this).attr("data-target");
    let ariaControls = jQuery(this).attr("aria-controls");

    jQuery("." + targetClass).toggleClass("is-checked");
    jQuery("body").toggleClass("is-checked");

    if (jQuery("#" + ariaControls).attr("aria-hidden") === "true") {
      jQuery("#" + ariaControls).attr("aria-hidden", "false");
    } else {
      jQuery("#" + ariaControls).attr("aria-hidden", "true");
    }

    if (jQuery(this).attr("aria-expanded") === "true") {
      jQuery(this).attr("aria-expanded", "false");
    } else {
      jQuery(this).attr("aria-expanded", "true");
    }

    return false;
  });

  // ★ .drawer-content 内のリンククリックでメニューを閉じる
  jQuery(".drawer-content a").on("click", function(e) {
    closeDrawer();
  });

  jQuery(".sp-btn").on("click", function() {
    jQuery(this)
      .next()
      .slideToggle();
  });
});


(function($){
  function calcOffset($target){
    if (!$target.length) return null;
    var headerH = $('header').innerHeight() || 0;
    var top = $target.offset().top;
    // ヘッダーがfixedでない場合に補正したくないならここで条件分岐も可
    return top;
  }

  function scrollToHash(hash, animate){
    var $t = $(hash === '#' ? 'html' : hash);
    var pos = calcOffset($t);
    if (pos == null) return;
    if (animate) {
      $('html, body').stop().animate({scrollTop: pos}, 300);
    } else {
      $('html, body').stop().scrollTop(pos);
    }
  }

  // クリック時（スペル注意: .no_smooth）
  $('a[href^="#"]:not(.no_smooth)').on('click', function(e){
    var hash = this.hash || $(this).attr('href');
    if (hash && hash !== '#') {
      e.preventDefault();
      scrollToHash(hash, true);
    }
  });

  // ページ遷移で # 付きで来たとき：ロード後に再補正
  // Swiperや画像で高さが変わるので少し遅らせる
  window.addEventListener('load', function(){
    if (location.hash) {
      // ブラウザの自動スクロールを打ち消してから補正
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      setTimeout(function(){ scrollToHash(location.hash, false); }, 150);
      // さらに再計算が必要なら追い打ち（任意）
      setTimeout(function(){ scrollToHash(location.hash, false); }, 400);
    }
  });

  // 同一ページ内でハッシュが変わった場合
  window.addEventListener('hashchange', function(){
    if (location.hash) scrollToHash(location.hash, true);
  });

});

jQuery(function() {
  // aimation呼び出し
  if (jQuery(".js-scroll-trigger").length) {
    scrollAnimation();
  }

  // aimation関数
  function scrollAnimation() {
    jQuery(window).scroll(function() {
      jQuery(".js-scroll-trigger").each(function() {
        let position = jQuery(this).offset().top,
          scroll = jQuery(window).scrollTop(),
          windowHeight = jQuery(window).height();

        if (scroll > position - windowHeight + 200) {
          jQuery(this).addClass("active");
        }
      });
    });
  }
  jQuery(window).trigger("scroll");
});

//wait
/* jQuery(function() {
  "use waits";

  var dialog = document.getElementById("dialog");
  var waits = document.getElementsByClassName("js-wait");
  var cancel = document.getElementById("cancel");
  var scrollpos;

  if (waits) {
    for (let i = 0; i < waits.length; i++) {
      waits[i].addEventListener(
        "click",
        function() {
          dialog.style.visibility = "visible";
          dialog.style.opacity = 1;
          //scrollpos = jQuery(window).scrollTop();
          jQuery("body").addClass("fixed");
          //.css({ overflow: hidden });
        },
        false
      );
    }

    cancel.addEventListener("click", function() {
      jQuery("body").removeClass("fixed");
      //.css({ overflow: auto });
      //window.scrollTo(0, scrollpos);
      dialog.style.visibility = "hidden";
      dialog.style.opacity = 0;
    });
  }
}); */

if (window.matchMedia("(min-width: 769px)").matches) {
  /* ウィンドウサイズが 768px以上の場合に有効にしたい処理*/
}
var _window = jQuery(window),
  _header = jQuery("header"),
  heroBottom;

_window.on("scroll", function() {
  heroBottom1 = jQuery(".mv").height() - 120;
  heroBottom2 = jQuery(".header-logo").height();
  heroBottom = heroBottom1 - heroBottom2;
  if (_window.scrollTop() > heroBottom1) {
    _header.addClass("transform");
  } else {
    _header.removeClass("transform");
  }
});
_window.trigger("scroll");

var urlHash = location.hash;
if (urlHash) {
  jQuery("body,html")
    .stop()
    .scrollTop(0);

  setTimeout(function() {
    var target = jQuery(urlHash);

    if (window.matchMedia("(min-width: 769px)").matches) {
      var position = target.offset().top - 60;
    } else {
      var position = target.offset().top - 100;
    }
    //ランダムっぽいのでどちらにも対応
    jQuery("body,html")
      .stop()
      .animate({ scrollTop: position }, 300);
    console.log(header);
    console.log(position);
  }, 100);
}

jQuery(function() {
  jQuery(".faq-item-ttl").each(function() {
    jQuery(this).on("click", function() {
      jQuery(this).toggleClass("on");
      jQuery(this)
        .next(".faq-item-content")
        .slideToggle();
      return false;
    });
  });
});

jQuery(document).ready(function() {
  // /jQuery(".floating").hide(); //ボタンを非表示にする
  jQuery(window).on("scroll", function() {
    let scrollTop = jQuery(window).scrollTop(); // スクロール上部の位置
    let headerHeight = jQuery("header").innerHeight();

    scrollHeight = jQuery(document).height(); //ドキュメントの高さ
    scrollPosition = jQuery(window).height() + jQuery(window).scrollTop(); //現在地
    footHeight = jQuery("footer").outerHeight(true); //止めたい位置の高さ(今回はfooter)
    stopHeight = footHeight;

    bottomHeight = footHeight;

    if (window.matchMedia("(min-width: 751px)").matches) {
      if (scrollHeight - scrollPosition <= stopHeight) {
        //ドキュメントの高さと現在地の差がfooterの高さ以下の時
        jQuery(".floating").css({
          position: "absolute", //pisitionをabsoluteに変更
          bottom: bottomHeight
        });
      } else {
        //それ以外の場合は
        jQuery(".floating").css({
          position: "fixed", //固定表示
          bottom: "0px"
        });
      }
    }

    scrollHeight = jQuery(document).height(); //ドキュメントの高さ
    scrollPosition = jQuery(window).height() + jQuery(window).scrollTop(); //現在地
    footHeight = jQuery("footer").innerHeight(); //止めたい位置の高さ(今回はfooter)
    stopHeight = footHeight;
  });
});

window.onload = function() {
  //ラッパー要素を指定
  var sliderWrap = document.querySelectorAll(".slider-wrap");
  //メインのスライダーを指定
  var sliderMain = document.querySelectorAll(".slider-main");
  //slider-wrapの数だけ繰り返す
  for (let i = 0; i < sliderWrap.length; i++) {
    //.slider-wrap、.slider-thumb、.slider-mainに01から始まる連番を振る
    var num = ("00" + (i + 1)).slice(-2);
    sliderMain[i].classList.add("slider-main" + num);
    var nextClass = sliderWrap[i].querySelector(".swiper-button-next");
    var prevClass = sliderWrap[i].querySelector(".swiper-button-prev");
    //メインのスライダー呼び出し&オプション指定
    var swiperMain = new Swiper(".slider-main" + num, {
      slidesPerView: 1,
      effect: "cards",
      centeredSlides: true, // アクティブなスライドを中央に配置する
      loop: true, // 無限ループさせる
      loopAdditionalSlides: 1, // 無限ループさせる場合に複製するスライド数
      navigation: {
        nextEl: nextClass,
        prevEl: prevClass
      }
    });
  }
};
